import React,  { useState } from "react";
import { Formik } from "formik";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";


import { Checkbox, TextField,MenuItem } from "@material-ui/core";
import clsx from "clsx";
import * as auth from "../../store/ducks/auth.duck";
import { createTier,getAccountTypes} from "../../crud/auth.crud";

import CodeExample from "../../partials/content/CodeExample";



function CreateTier(props) {
  
  //console.log('Loaded CreateUser',props);
  
  const { intl } = props;
   
   let isLoaded = false;
const [statusColor, setStatusColor] = useState('alert-success');

const [accountTypes,setAccountTypes] =useState({accountType:[]});

  React.useEffect(() => {
        const fetchAccountTypes = async () => {
            try {
                
                const response = await getAccountTypes()
                setAccountTypes({accountType: response.data});
            } catch (e) {
                console.log(e);
                
            }
        };
        fetchAccountTypes();
    }, []);


  const [loading, setLoading] = useState(false);
  const [loadingButtonStyle, setLoadingButtonStyle] = useState({
    paddingRight: "2.5rem"
  });

 
  const enableLoading = () => {
    setLoading(true);
    setLoadingButtonStyle({ paddingRight: "3.5rem" });
  };

  const disableLoading = () => {
    setLoading(false);
    setLoadingButtonStyle({ paddingRight: "2.5rem" });
  };






  return (

      <Formik
                  initialValues={{
                    accountTypeName: "",
                    typeDescription: "",
                    bannerDisplayTime: "",
                    allocatedStorage: "",
                    allocatedUsers:"",
                   
                    
                  }}
                  validate={values => {
                    const errors = {};

                    
                    if (!values.accountTypeName) {
                      errors.accountTypeName = intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    if (!values.typeDescription) {
                      errors.typeDescription = intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    if (!values.bannerDisplayTime) {
                      errors.bannerDisplayTime = intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    if (!values.allocatedStorage) {
                      errors.allocatedStorage = intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    if (!values.allocatedUsers) {
                      errors.allocatedUsers = intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                     

                    
                    return errors;
                  }}
                  onSubmit={(values, { setStatus, setSubmitting }) => {

                    enableLoading();
                    
                    createTier(
                      values.accountTypeName,
                      values.typeDescription,
                      values.bannerDisplayTime,
                      values.allocatedStorage,
                      values.allocatedUsers,
                      accountTypes.accountType.length+1
                    )
                      .then(resp => {
                        //props.register(accessToken);
                       
                        disableLoading();
                        setStatus(
                          intl.formatMessage({
                            id: "CREATION.SUCCESS.MESSAGE"
                          })
                        );
                        setStatusColor('alert-success');
                        window.scrollTo(0,0);
                       
                      })
                      .catch(() => {
                        disableLoading();
                        setSubmitting(false);
                        setStatus(
                          intl.formatMessage({
                            id: "AUTH.VALIDATION.INVALID_LOGIN"
                          })
                        );
                        setStatusColor('alert-danger');
                      });
                  }}
                >
                  {({
                    values,
                    status,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,

                    
                  }) => (
                    <form onSubmit={handleSubmit} noValidate autoComplete="off">
                      {status && (
                        <div role="alert" className={"alert "+statusColor}>
                          <div className="alert-text">{status}</div>
                        </div>
                      )}

    <CodeExample beforeCodeTitle="Basic Details">
          <div className="kt-section">
            <div className="kt-section__content">


                  <div className="form-group mb-0">
                        <TextField
                          margin="normal"
                          label="Tier"
                          className="kt-width-full"
                          name="accountTypeName"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.accountTypeName}
                          helperText={touched.accountTypeName && errors.accountTypeName}
                          error={Boolean(touched.accountTypeName && errors.accountTypeName)}
                        />
                      </div>    

                      <div className="form-group mb-0">
                        <TextField
                          margin="normal"
                          label="Description"
                          className="kt-width-full"
                          name="typeDescription"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.typeDescription}
                          helperText={touched.typeDescription && errors.typeDescription}
                          error={Boolean(touched.typeDescription && errors.typeDescription)}
                        />
                      </div> 

                      <div className="form-group mb-0">
                        <TextField
                          margin="normal"
                          label="Banner Display Time (in Seconds)"
                          type="number"
                          className="kt-width-full"
                          name="bannerDisplayTime"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.bannerDisplayTime}
                          helperText={touched.bannerDisplayTime && errors.bannerDisplayTime}
                          error={Boolean(touched.bannerDisplayTime && errors.bannerDisplayTime)}
                        />
                      </div>

                      <div className="form-group mb-0">
                        <TextField
                          margin="normal"
                          label="Allocated Storage (in GB)"
                          type="number"
                          className="kt-width-full"
                          name="allocatedStorage"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.allocatedStorage}
                          helperText={touched.allocatedStorage && errors.allocatedStorage}
                          error={Boolean(touched.allocatedStorage && errors.allocatedStorage)}
                        />
                      </div>

                      <div className="form-group mb-0">
                        <TextField
                          margin="normal"
                          label="Allocated Users"
                          type="number"
                          className="kt-width-full"
                          name="allocatedUsers"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.allocatedUsers}
                          helperText={touched.allocatedUsers && errors.allocatedUsers}
                          error={Boolean(touched.allocatedUsers && errors.allocatedUsers)}
                        />
                      </div>
              

                      
                 
        </div>
        </div>
        </CodeExample>
        <div className="kt-login__actions">
                       

                        <button
                          disabled={isSubmitting}
                         type="submit"
                            className={`btn btn-primary btn-elevate kt-login__btn-primary ${clsx(
                              {
                                "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": loading
                              }
                            )}`}
                            style={loadingButtonStyle}
                          >
                           Create Tier
                        </button>
                      </div>
        </form>
         )}
                </Formik>
                
  );
}


export default injectIntl(
  connect(
    null,
    auth.actions
  )(CreateTier)
);
